import Collapse from 'antd/lib/collapse';
import Typography from 'antd/lib/typography';
import React from 'react';

export const CollapseFilterWrapper: React.FC<{ children: React.ReactNode; label: string }> = ({ children, label }) => {
    return (
        <Collapse
            style={{
                width: '100%',
                borderRadius: 0,
                padding: 0,
                margin: 0,
                backgroundColor: 'white',
                borderTop: '1px solid #f0f0f0',
                borderBottom: '1px solid #f0f0f0',
            }}
            ghost
            destroyOnHidden={false}
            expandIconPosition="end"
            defaultActiveKey={['1']}
            items={[
                {
                    key: '1',
                    label: <Typography.Text strong>{label}</Typography.Text>,
                    children,
                    styles: {
                        body: { padding: 0 },
                    },
                },
            ]}
        />
    );
};
